import { useEffect, useReducer } from 'react';

import { actions, homepageReducer, initialState } from '../Store';
import { getHeroBanner } from '../../../services/homepage';

const useHeroBanner = () => {
  const [{ heroBanner }, stateDispatch] = useReducer(homepageReducer, initialState());

  useEffect(() => {
    stateDispatch(actions.getHeroBanner());
    getHeroBanner()
      .then((data) => stateDispatch(actions.getHeroBannerSuccess(data)))
      .catch((error) => stateDispatch(actions.getHeroBannerFail(error)));
  }, []);

  return heroBanner;
};

export default useHeroBanner;
